import React from "react";

function Contact() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8">
        Contact Us
      </h1>
      <div className="flex flex-col lg:flex-row items-start lg:justify-start gap-8">
        {/* Address Section */}
        <div className="lg:w-1/4 w-full bg-gray-100 p-4 sm:p-6 rounded-lg shadow h-96">
          <div className="flex flex-col space-y-6 h-full">
            {/* Address Section 1 */}
            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-4 text-center lg:text-left">
                Our Address
              </h2>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed text-center lg:text-left">
                House 75, Block B, Road 1, Niketon, Dhaka-1212
              </p>
            </div>

            {/* Address Section 2 */}
            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-4 text-center lg:text-left">
                Email
              </h2>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed text-center lg:text-left">
                info@materialsindexbd.com
              </p>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="lg:w-3/4 w-full h-96">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.284905143865!2d90.41031701096082!3d23.772866887824325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c782a4595451%3A0xbd7fd0c5af1227d7!2s75%20Road%20No.%201%2C%20Dhaka%201212!5e0!3m2!1sen!2sbd!4v1737190611736!5m2!1sen!2sbd"
            className="w-full h-full rounded-lg shadow"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      </div>

      {/* Form Section */}
      <div className="mt-12">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6">
          Get in Touch
        </h2>
        <form className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Name Field */}
          <div className="flex flex-col">
            <label htmlFor="name" className="text-sm font-semibold mb-2">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name ..."
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Date Field */}
          <div className="flex flex-col">
            <label htmlFor="date" className="text-sm font-semibold mb-2">
              Date
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Telephone Field */}
          <div className="flex flex-col">
            <label htmlFor="telephone" className="text-sm font-semibold mb-2">
              Telephone <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              id="telephone"
              placeholder="Enter your telephone number ..."
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Email Field */}
          <div className="flex flex-col">
            <label htmlFor="email" className="text-sm font-semibold mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email ..."
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Subject Field */}
          <div className="flex flex-col sm:col-span-2">
            <label htmlFor="subject" className="text-sm font-semibold mb-2">
              Subject <span className="text-red-500">*</span>
            </label>
            <textarea
              id="subject"
              placeholder="Write ..."
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
              required
            ></textarea>
          </div>

          {/* Message Field */}
          <div className="flex flex-col sm:col-span-2">
            <label htmlFor="message" className="text-sm font-semibold mb-2">
              Your Message <span className="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              placeholder="Write ..."
              className="p-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
              required
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className="sm:col-span-2 text-center">
            <button
              type="submit"
              className="bg-yellow-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-yellow-600 transition-all duration-200"
            >
              Submit Button
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contact;


// import React from "react";

// function Contact() {
//   return (
//     <div className="container mx-auto p-6">
//       <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8">
//         Contact Us
//       </h1>
//       <div className="flex flex-col lg:flex-row items-start lg:justify-between gap-8">
//         {/* Address Section */}
//         <div className="w-full lg:w-1/3 bg-gray-100 p-4 sm:p-6 rounded-lg shadow">
//           <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-center lg:text-left">
//             Our Address
//           </h2>
//           <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-center lg:text-left">
//             House 75, Block B, Road 1, Niketon, Dhaka-1212
//           </p>
//         </div>


//         {/* Map Section */}
//         <div className="lg:w-2/3 w-full h-64 sm:h-80 md:h-96">
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.284905143865!2d90.41031701096082!3d23.772866887824325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c782a4595451%3A0xbd7fd0c5af1227d7!2s75%20Road%20No.%201%2C%20Dhaka%201212!5e0!3m2!1sen!2sbd!4v1737190611736!5m2!1sen!2sbd"
//             className="w-full h-full rounded-lg shadow"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             referrerPolicy="no-referrer-when-downgrade"
//             title="Google Map"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Contact;
